export const reviewTypes = {
    LOAD_REQUEST: 'revies list request to load',
    LOAD_SUCCESS: 'review list is ready',
    LOAD_ERROR: 'review list has errors',

    ADD_REQUEST: 'request to add new review ',
    ADD_SUCCESS: 'new review is added ',
    ADD_ERROR: 'new review not added - has errors ',

    REMOVE: 'product is removed after sending new review ',
    CLEAR: 'review clear',
};
